// Subtle loading shimmer used across dashboard cards.
export const SkeletonBar = ({ className = "" }) => (
  <div
    className={`animate-pulse bg-zinc-800/70 rounded-[2px] ${className}`}
    data-testid="skeleton-bar"
  />
);

export const SkeletonRows = ({ rows = 6, cols = 6 }) => (
  <div className="px-3 py-2 space-y-2.5" data-testid="skeleton-rows">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-3">
        {Array.from({ length: cols }).map((_, c) => (
          <SkeletonBar
            key={c}
            className={`h-3 ${c === 0 ? "w-[16%]" : "flex-1"}`}
          />
        ))}
      </div>
    ))}
  </div>
);
